<template>
	<div class="container">
		<h2 class="form-signin-heading" aria-hidden="false">
			Reset your Password
		</h2>
		<b-form @submit.prevent="submitForm">
			<b-form-group
				id="emailGroup"
				label="Enter your email"
				label-for="email"
				label-class="hidden"
			>
				<b-form-row>
					<b-form-input
						id="email"
						type="email"
						class="form-control"
						name="email"
						placeholder="email@example.com"
						:value="route_email"
						:plaintext="true"
						v-focus
					></b-form-input>
				</b-form-row>
			</b-form-group>
			<b-form-group
				id="passwordGroup"
				label="Enter your password"
				label-for="password"
				label-class="hidden"
				:state="passwordState"
				:invalid-feedback="passwordInvalidFeedback"
			>
				<b-form-row>
					<b-form-input
						id="password"
						type="password"
						:state="passwordState"
						v-model.trim="password"
						class="form-control"
						name="password"
						required
						placeholder="Password"
						v-focus
					></b-form-input>
					<b-form-text id="inputLiveHelp">
						Minimum of 8 characters that has at least 1 of each of the
						following: lowercase letter, uppercase letter, number and
						!@#$%^&*()_-+{}[]|&lt;&gt;?~
					</b-form-text>
				</b-form-row>
			</b-form-group>
			<b-form-group
				id="passwordConfirmGroup"
				label="Confirm your password"
				label-for="passwordConfirm"
				label-class="hidden"
				:state="passwordConfirmState"
				:invalid-feedback="passwordConfirmInvalidFeedback"
			>
				<b-form-row>
					<b-form-input
						id="passwordConfirm"
						type="password"
						:state="passwordConfirmState"
						v-model.trim="passwordConfirm"
						class="form-control"
						name="passwordConfirm"
						required
						placeholder="Confirm Password"
					></b-form-input>
				</b-form-row>
			</b-form-group>
			<b-form-group>
				<b-form-row>
					<b-col>
						<b-button
							:disabled="disableForm()"
							variant="primary"
							class="formSubmit"
							type="submit"
						>
							Reset Password
						</b-button>
					</b-col>
					<b-col>
						<router-link to="/">
							<b-button
								variant="secondary"
								size="sm"
								class="formSubmit float-right"
							>
								Cancel
							</b-button>
						</router-link>
					</b-col>
				</b-form-row>
			</b-form-group>
		</b-form>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "CreateAccount",
	props: ["route_email", "route_token"],
	data: function() {
		return {
			password: null,
			passwordConfirm: null
		};
	},
	computed: {
		...mapGetters(["userType"]),
		passwordState() {
			if (this.password === null) {
				return null;
			}
			return this.isValidPassword();
		},
		passwordConfirmState() {
			if (this.passwordConfirm === null) {
				return null;
			}
			return this.isValidPasswordConfirm();
		},
		passwordInvalidFeedback() {
			if (this.password === "") {
				return "Password is required";
			}
			return "";
		},
		passwordConfirmInvalidFeedback() {
			if (this.password === "") {
				return "Both password fields are required";
			}
			if (this.password !== this.passwordConfirm) {
				return "Passwords do not match";
			}
			return "";
		}
	},
	methods: {
		passwordIsComplex() {
			if (this.password.length < 8) {
				return false;
			}
			if (!/[a-z]+/.test(this.password)) {
				return false;
			}
			if (!/[A-Z]+/.test(this.password)) {
				return false;
			}
			if (!/[0-9]+/.test(this.password)) {
				return false;
			}

			return /[!@#$%^&*()_\-+{}[\]|<>?~]+/.test(this.password);
		},
		isValidPassword() {
			return (
				this.password !== "" &&
				this.password !== null &&
				this.passwordIsComplex()
			);
		},
		isValidPasswordConfirm() {
			return (
				this.passwordConfirm !== "" &&
				this.passwordConfirm !== null &&
				this.password === this.passwordConfirm
			);
		},
		disableForm() {
			return !(this.isValidPassword() && this.isValidPasswordConfirm());
		},
		submitForm() {
			this.$store.dispatch("reset_password", {
				email: this.route_email,
				password: this.password,
				passwordConfirm: this.passwordConfirm,
				token: this.route_token
			});
		}
	},
	created() {
		this.$store.dispatch("check_reset_token", {
			email: this.route_email,
			token: this.route_token
		});
	},
	watch: {
		userType(value) {
			if (value === "authed") {
				this.$router.push("/applications");
			} else if (value === "new") {
				this.$router.push("/");
			}
		}
	}
};
</script>

<style scoped></style>
